// userHooks.js - Custom hooks for user management
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  reset,
  deleteUser,
  forceLogoutUser,
  loadUser,
  saveUser,
  updateUser,
} from "./index";

/**
 * Hook for user management functionality
 */

export const useUser = () => {
  const dispatch = useDispatch();
  const userState = useSelector((state) => state.user);

  // Delete a user
  const handleDeleteUser = useCallback(
    (userId, clipsOnly = false) => {
      return dispatch(deleteUser({ userId, clipsOnly }));
    },
    [dispatch]
  );

  // Force logout a user
  const handleForceLogout = useCallback(
    (userId) => {
      return dispatch(forceLogoutUser(userId));
    },
    [dispatch]
  );

  // Load user data
  const handleLoadUser = useCallback(
    (userId) => {
      return dispatch(loadUser(userId));
    },
    [dispatch]
  );

  // Reset user state
  const handleResetUser = useCallback(() => {
    dispatch(reset());
  }, [dispatch]);

  // Save user data
  const handleSaveUser = useCallback(
    (userData) => {
      return dispatch(saveUser(userData));
    },
    [dispatch]
  );

  // Update specific fields in the user state
  const handleUpdateUser = useCallback(
    (fields) => {
      dispatch(updateUser(fields));
    },
    [dispatch]
  );

  return {
    // State
    user: userState.user,
    isLoaded: userState.loaded,
    isLoading: userState.loading,
    isSaving: userState.saving,
    isSaved: userState.saved,
    isDeleted: userState.deleted,
    isDeleting: userState.deleting,

    // Actions
    deleteUser: handleDeleteUser,
    forceLogoutUser: handleForceLogout,
    loadUser: handleLoadUser,
    reset: handleResetUser,
    saveUser: handleSaveUser,
    updateUser: handleUpdateUser,
  };
};
